module.exports = __webpack_public_path__ + "static/media/team-chile.8901b6af.png";